module.exports = __webpack_public_path__ + "media/images/logo-969b9a7d7c4b65f55841f51b8b7d8b89.jpg";